import {
  Dispatch,
  useState
} from 'react';
import {LicenseOrganizationController} from '../../../../api/license/license-organization.controller';
import {OrganizationController} from '../../../../api/organization/organization.controller';
import {SupportPlanController} from '../../../../api/support/support-plan.controller';
import {
  useAsyncEffect,
  useInitialLoad
} from '../../../../hook/use-initial-load';
import {LicenseOrganizationModel} from '../../../../model/license/license-organization.model';
import {OrganizationData} from '../../../../model/organization/organization-data';
import {SupportCustomerPlanModel} from '../../../../model/support/support-customer-plan.model';

export namespace OrganizationListPageHooks {
  export const useOrganizations = (): [OrganizationData[], Dispatch<OrganizationData[]>] => {
    const [organizationsResult, setOrganizationsResult] = useState<OrganizationData[]>([]);
    useAsyncEffect(async () => {
      setOrganizationsResult(await fetchOrganizations())
    }, []);
    return [organizationsResult, setOrganizationsResult];
  }

  export const useOrganizationsLicense = (organizations: OrganizationData[]): [LicenseOrganizationModel[], Dispatch<LicenseOrganizationModel[]>] => {
    const [organizationLicenses, setOrganizationLicenses] = useState<LicenseOrganizationModel[]>([]);
    useAsyncEffect(async () => {
      if(organizations && organizations.length > 0) {
        setOrganizationLicenses(await fetchOrganizationsLicense(organizations.map(it => it.id)))
      }
    }, [organizations]);
    return [organizationLicenses, setOrganizationLicenses];
  }

  export const fetchOrganizations = async (): Promise<OrganizationData[]> =>
    (await OrganizationController.fetchOrganizations())

  export const fetchOrganizationsLicense = async (organizationIds: string[]): Promise<LicenseOrganizationModel[]> =>
    (await LicenseOrganizationController.queryFeatureTemplates(organizationIds))
}